import { TemplateResult, html } from 'lit';
import {
  LightDomStyles,
  OutlineElement,
  SlotsController,
} from '@phase2/outline-core';
import { customElement } from 'lit/decorators.js';
import componentStyles from './outline-link-grid-block.css.lit';

/**
 * The Link Grid Block component
 * @element outline-link-grid-block
 */
@customElement('outline-link-grid-block')
export class OutlineLinkGridBlock extends OutlineElement {
  static styles = [componentStyles];

  lightDomStyles = new LightDomStyles(
    this,
    componentStyles,
    this.tagName.toLowerCase()
  );

  slots = new SlotsController(this);

  render(): TemplateResult {
    return html`
      <div class="link-grid-block">
        ${this.slots.conditionalSlot('heading', false)}
        <slot></slot>
      </div>
    `;
  }
}
